import { DarkModeContextProvider } from './contexts/DarkModeContext';
import { QueryClientProvider, QueryClient } from 'react-query';
import { UserContextProvider } from './contexts/UserContext';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import React from 'react';
import App from './App';
import './index.css';
import { WalletContextProvider } from './contexts/WalletContext';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <DarkModeContextProvider>
        <UserContextProvider>
          <WalletContextProvider>
            <QueryClientProvider client={queryClient} >
              <App />
            </QueryClientProvider>
          </WalletContextProvider>
        </UserContextProvider>
      </DarkModeContextProvider>
    </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
